import { CostArgs } from '../../../../utils'
import { QuebecPurchaseTaxes } from '../purchase-taxes'

export const PurchaseTaxes = (args: CostArgs) =>
  ({
    ...QuebecPurchaseTaxes(args),
  } as const)
